import { 
    getToken, 
    // setToken, 
    removeToken 
} from "@/utils/auth";
export default {

    helpOrderMemberLogin(that,postObj,loading){
        that.$store.dispatch("member/login", postObj).then(res=>{
            if(res.code >= 0){
                loading && loading.close();
                let href = window.location.href;
                href = href.split("?")[0];
                window.location.href = href;
            }
        }).catch(err=>{
            loading && loading.close();
            that.$message.error((err && err.message) || "登录失败，请稍后重试");
        })
    },
    helpOrderInit(that) {
        let query = that.$route.query;
        if (query) {
            let { type, random, member_id } = query;
            if (type && type == "help_order" && member_id && random) {
                // element ui 弹出确认警告

                that.$confirm("检测到帮下单跳转，是否登录？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then((val) => {
                    if (val) {
                        // element ui 页面loading
                        let loading = that.$loading({
                            lock: true,
                            text: "登录中...",
                            background: "rgba(0, 0, 0, 0.7)"
                        });
                        let token = getToken();
                        let postObj = {
                            // username,
                            // password: "jxkj123"
                            member_id,
                            random,
                            type
                        };
                        if(token){
                            removeToken();
                            sessionStorage.clear();
                            setTimeout(()=>{
                                this.helpOrderMemberLogin(that,postObj,loading);
                            },200);
                        }else{
                            this.helpOrderMemberLogin(that,postObj,loading);
                        }
                    }
                }).catch(() => {

                });
            }
        }
    }
}